function S(e = /* @__PURE__ */ new Date()) {
  const n = e.getFullYear(), t = (e.getMonth() + 1).toString().padStart(2, "0"), r = e.getDate().toString().padStart(2, "0");
  return `${n}-${t}-${r}`;
}
function P() {
  return S();
}
function R() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
class d extends Error {
  constructor(n) {
    const t = `'${n}' is not a valid date`;
    super(t);
  }
}
class y extends Error {
  constructor(n) {
    const t = `'${n}' is not a valid style`;
    super(t);
  }
}
function l(e, n) {
  return Array.from({ length: n - e + 1 }, (r, c) => String(c + e).padStart(2, "0"));
}
const Z = l(1, 12).join("|"), v = l(1, 31).join("|"), x = l(0, 23).join("|"), D = l(0, 59).join("|"), E = D, h = `(\\d{4})-(${Z})-(${v})`, F = `(${x}):(${D}):(${E})`, I = "(\\d{3})", A = new RegExp(`^${h}$`), j = new RegExp(`^${h}T${F}(\\.${I})?Z$`), b = /^\d{13}$/;
function L(e) {
  return A.test(e);
}
function m(e) {
  return j.test(e);
}
function f(e) {
  return b.test(e.toString());
}
function T() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $(e, n) {
  return `${e} (${n})`;
}
function s(e, { timeZone: n, locale: t, style: r, forceTZ: c, hideTZ: o }) {
  const i = T(), u = Intl.DateTimeFormat(t, {
    dateStyle: r,
    timeZone: n
  }).format(e);
  return o ? u : i !== n || c ? $(u, n) : u;
}
function k(e, n) {
  if (!e)
    return "";
  if (n != null && n.style && !["long", "full", "medium", "short"].includes(n == null ? void 0 : n.style))
    throw new y(n == null ? void 0 : n.style);
  const t = {
    timeZone: "Europe/Paris",
    locale: "default",
    style: "long",
    forceTZ: !1,
    hideTZ: !1,
    ...n
  };
  if (e instanceof Date)
    return s(e, t);
  if (typeof e == "string") {
    if (L(e))
      return t.timeZone = "UTC", t.hideTZ = !0, s(new Date(e), t);
    if (m(e))
      return s(new Date(e), t);
  }
  if (typeof e == "number" && f(e))
    return s(e, t);
  throw new d(e);
}
const a = {
  year: "numeric",
  hour: "numeric",
  minute: "numeric"
}, M = {
  long: {
    ...a,
    month: "long",
    day: "numeric"
  },
  full: {
    ...a,
    month: "long",
    day: "numeric",
    weekday: "long"
  },
  short: {
    ...a,
    month: "numeric",
    day: "numeric"
  }
};
function g(e, { timeZone: n, style: t, locale: r, showSeconds: c, forceTZ: o }) {
  const i = T(), u = Intl.DateTimeFormat(r, {
    ...M[t],
    second: c ? "numeric" : void 0,
    timeZone: n
  }).format(e);
  return i !== n || o ? $(u, n) : u;
}
function C(e, n) {
  if (!e)
    return "";
  if (n != null && n.style && !["long", "full", "short"].includes(n == null ? void 0 : n.style))
    throw new y(n == null ? void 0 : n.style);
  const t = {
    timeZone: "Europe/Paris",
    locale: "default",
    style: "long",
    forceTZ: !1,
    showSeconds: !1,
    ...n
  };
  if (e instanceof Date)
    return g(e, t);
  if (typeof e == "string" && m(e))
    return g(new Date(e), t);
  if (typeof e == "number" && f(e))
    return g(e, t);
  throw new d(e);
}
export {
  k as asDate,
  C as asDatetime,
  S as getDateOnly,
  R as now,
  P as today,
  L as validateDateString,
  m as validateDatetimeString,
  f as validateTimestamp
};
//# sourceMappingURL=date-utils.mjs.map
